import { z } from "zod";

const zConstraint = z.enum(["UNIQUE_ROLE_NAME"]);
const Constraint = zConstraint.Values;
type Constraint = z.infer<typeof zConstraint>;

export { Constraint, zConstraint };
